module.exports = __webpack_public_path__ + "assets/img/titleh1.2459e8d1.png";